<script lang="ts">
  import { tutorialData, type TutorialData } from './modals';

  let onConfirm: Function | undefined = undefined;

  let anchor: HTMLElement | null = $state(null);
  let position = $state({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    value: '',
  });
  let highlightBorders = $state({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  });
  let size: 'small' | 'medium' | 'large' = 'medium';
  let data: TutorialData | null = $state(null);

  let modalView: HTMLDivElement;

  tutorialData.subscribe((value) => {
    data = value;
    if (anchor) {
      anchor.classList.remove('tutorial-highlighted');
    }

    position = {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      value: '',
    };
    highlightBorders = {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    };

    if (value) {
      if (value.onConfirm) {
        onConfirm = value.onConfirm;
      }

      if (value.anchor) {
        anchor = document.querySelector(value.anchor.selector);

        if (anchor) {
          // anchor.scrollIntoView({behavior: 'smooth'});

          // add special highlighted class to element
          anchor.classList.add('tutorial-highlighted');

          //calculate element corners
          let rect = anchor.getBoundingClientRect();
          highlightBorders.top = rect.top;
          highlightBorders.left = rect.left;
          highlightBorders.bottom = rect.bottom;
          highlightBorders.right = rect.right;

          //position the element so that it sits relative to the anchor element
          if (value.anchor.position == 'below') {
            position.top = highlightBorders.bottom + 23;
            position.left = highlightBorders.left + anchor.offsetWidth / 2;
          } else if (value.anchor.position == 'above') {
            position.bottom = window.innerHeight - highlightBorders.top + 23;
            position.left = highlightBorders.left + anchor.offsetWidth / 2;
          } else if (value.anchor.position == 'right') {
            position.left = highlightBorders.right + 23;
            position.top = highlightBorders.top + anchor.offsetHeight / 2;
          } else if (value.anchor.position == 'left') {
            position.right = window.innerWidth - highlightBorders.left + 23;
            position.top = highlightBorders.top + anchor.offsetHeight / 2;
          } else if (value.anchor.position == 'center') {
            // position.top = window.innerHeight/2;
            // position.left = window.innerWidth/2;
          }

          setTimeout(() => {
            /* if (!modalView) {
              modalView = document.getElementById(
                "tutorial-modal",
              ) as HTMLDivElement;
            } */
            //if any position is outside the page, bring it inside the page
            var width = modalView.offsetWidth / 2;
            var height = modalView.offsetHeight / 2;

            if (position.value == 'left' || position.value == 'right') {
              if (position.top && position.top + height > window.innerHeight) {
                position.top = window.innerHeight - height - 10;
              }
              if (position.top && position.top < 0) {
                position.top = 10;
              }
              if (position.bottom && position.bottom + height > window.innerHeight) {
                position.bottom = window.innerHeight - height - 10;
              }
              if (position.bottom && position.bottom < 0) {
                position.bottom = 10;
              }
            }

            if (position.value == 'below' || position.value == 'above') {
              if (position.left && position.left + width > window.innerWidth) {
                position.left = window.innerWidth - width - 10;
              }
              if (position.left && position.left < 0) {
                position.left = 10;
              }
              if (position.right && position.right + width > window.innerWidth) {
                position.right = window.innerWidth - width - 10;
              }
              if (position.right && position.right < 0) {
                position.right = 10;
              }
            }
            position = position;
          }, 100);

          position.value = value.anchor.position;
        }
      } else {
        //center the modal
        position.top = NaN;
        position.left = NaN;
        position.bottom = NaN;
        position.right = NaN;
      }
    } else {
      onConfirm = undefined;
    }
  });

  const confirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    if ($tutorialData && $tutorialData.callback) {
      $tutorialData.callback();
    }
    tutorialData.set(null);
  };

  const skip = () => {
    if ($tutorialData && $tutorialData.callback) {
      $tutorialData.callback(true);
    }
    tutorialData.set(null);
  };
</script>

{#if data}
  <div class="modal-container tutorial-container">
    <div
      class="modal-center"
      style="
      top: {position.top}px;
      left: {position.left}px;
      bottom: {position.bottom}px;
      right: {position.right}px;
      {position.value == 'below' || position.value == 'above'
        ? 'width: 0px;'
        : 'height: 0px; flex-direction: column'}
    "
    >
      <div class="caret {position.value}"></div>

      <div id="tutorial-modal" class="modal {size}" bind:this={modalView}>
        {#if data.title}
          <div class="header">
            <h1>{data.title}</h1>
          </div>
        {/if}

        {#if data.text}
          <div class="body">
            <p>{@html data.text}</p>
            <img style="display:none" alt="" />
          </div>
        {/if}

        <div class="functions">
          <button class="btn" onclick={skip}>Skip</button>
          <button class="btn" onclick={confirm}>Continue</button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="highlight-box"
    style="
      top: {highlightBorders.top - 12}px;
      left: {highlightBorders.left - 12}px;
      bottom: {highlightBorders.bottom - 10}px;
      right: {highlightBorders.right - 1}px;
      width: {highlightBorders.right - highlightBorders.left + 20}px;
      height: {highlightBorders.bottom - highlightBorders.top + 20}px;
    "
  ></div>
{/if}

<style lang="less">
  /* :global(.tutorial-highlighted) {
    border: 2px solid white;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.75), 0 0 5px 5px white;
    z-index: 100;
  } */

  .highlight-box {
    border: 2px solid white;
    box-shadow:
      0 0 0 9999px rgba(0, 0, 0, 0.75),
      0 0 5px 5px white;
    z-index: 100;
    position: absolute;
    border-radius: 8px;
  }

  .tutorial-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 1000;
    background-color: transparent;

    .modal-center {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;

      .caret {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;

        z-index: 1001;

        &.above {
          bottom: -19px;
          border-top: 10px solid white;
        }
        &.below {
          top: -19px;
          border-bottom: 10px solid white;
        }
        &.left {
          right: -19px;
          border-left: 10px solid white;
        }
        &.right {
          left: -19px;
          border-right: 10px solid white;
        }
      }

      .modal {
        margin-top: unset;
        border-color: white;
        border-width: 2px;
        border-style: solid;
        padding: 20px;
        background-color: var(--background-colour);

        &.small {
          width: max(200px, 30vw);
        }
        &.medium {
          width: max(300px, 50vw);
        }
        &.large {
          width: max(400px, 70vw);
        }

        .header {
          text-align: center;
          justify-content: center;
        }

        .body {
          :global(img) {
            vertical-align: middle;
            width: 50px;
          }
        }
      }
    }
  }
</style>
